import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MenuViewModel } from '@nimbus-library/features/menu/models/menu.view-model';
@Injectable()
export abstract class IMenuProviderService {
  public abstract getMenu(): Observable<MenuViewModel>;
}
